// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e9fd6d5a","239":"1c3053f7","455":"99e5f910","884":"c4a70caa"}[chunkId] + ".chunk.js";
};